import { theme } from '@frontend/theme';
import { PolymorphicComponentPropWithoutRef } from '@frontend/design-system';

type Props = {
  removeDefaultStyles?: boolean;
};

type SettingsSectionProps<C extends React.ElementType> = PolymorphicComponentPropWithoutRef<C, Props>;

export const SettingsSection = <C extends React.ElementType = 'div'>({
  as,
  children,
  removeDefaultStyles,
  ...rest
}: SettingsSectionProps<C>) => {
  const Component = as || 'div';

  return (
    <Component
      css={
        !removeDefaultStyles
          ? {
              background: theme.colors.white,
              padding: theme.spacing(3),
              borderRadius: theme.borderRadius.medium,
              boxShadow: theme.shadows.light,
            }
          : {}
      }
      {...rest}
    >
      {children}
    </Component>
  );
};
